<script lang="ts">
    export let value: Date
    export let locale = "de-DE"

    $: if (value && typeof value != "object") {
        value = new Date(value)
    }
</script>

{#if value}
    {value.toLocaleDateString(locale, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
    })}
{/if}
